import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyA3CWT2HHBSpWcmY1CiZ4cya9oOh0j5BvM",
  authDomain: "facebook-messenger-clone-e0058.firebaseapp.com",
  databaseURL: "https://facebook-messenger-clone-e0058.firebaseio.com",
  projectId: "facebook-messenger-clone-e0058",
  storageBucket: "facebook-messenger-clone-e0058.appspot.com",
  messagingSenderId: "353833339272",
  appId: "1:353833339272:web:10861d3e0bda54db76d23d",
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

const db = firebase.firestore();

export default db;
